import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import type { BillingSummary, OveragesResponse } from '@/lib/types'

const BILLING_SUMMARY_KEY = ['billing', 'summary'] as const
const OVERAGES_KEY = ['billing', 'overages'] as const

export function useBillingSummary(): ReturnType<typeof useQuery<BillingSummary>> {
  return useQuery({
    queryKey: BILLING_SUMMARY_KEY,
    queryFn: () => apiClient.get<BillingSummary>(endpoints.billing.summary),
  })
}

export function useOverages(): ReturnType<typeof useQuery<OveragesResponse>> {
  return useQuery({
    queryKey: OVERAGES_KEY,
    queryFn: () => apiClient.get<OveragesResponse>(endpoints.billing.overages),
  })
}
